import type { Client } from '@openfeature/web-sdk';
import { createContext } from 'react';

export const FeatureFlagContext = createContext<Client | null>(null);
FeatureFlagContext.displayName = 'FeatureFlagContext';
